'use client'

import { InspirationalClientLink } from '@fukku/button/ClientLink/Inspirational/InspirationalClientLink'
import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'
import styles from './SiteCrumb.module.css'

interface SiteCrumbProps {
	readonly href: string
	readonly label?: string
	readonly sectionId?: string
	readonly analyticsEventData?: Record<string, string | number>
}

const CLICK_BREADCRUMB = 'click_breadcrumb'

export const SiteCrumb = ({
	href,
	label,
	sectionId,
	analyticsEventData,
}: SiteCrumbProps) => {
	const handleSendAnalytics = () => {
		sendGenericEvent(CLICK_BREADCRUMB, analyticsEventData)
	}

	return (
		<InspirationalClientLink
			className={styles.link}
			sectionId={sectionId}
			linkProps={{ itemProp: 'item' }}
			href={href}
			onClick={handleSendAnalytics}
		>
			<span itemProp='name'>{label}</span>
		</InspirationalClientLink>
	)
}
